<template>
  <div>
    <v-app-bar
        app
        dense
        flat
        clipped-left
        color="transparent"
        class="app-bar-bg"
        :style="{background: colorArrayToLinearGradient([
            `${barColor}99`,
            `${barColor}60`,
            `${barColor}40`,
            `${barColor}20`,
            `${barColor}10`,
            `${barColor}00`,
            ], 180)}"
    >
      <v-app-bar-nav-icon v-if="isMobile" @click="drawer = true"  :disabled="!isOnBoardingDone"></v-app-bar-nav-icon>
      <img
          v-else
          alt="kim-logo"
          height="24"
          :src="require('@/assets/img/logo/rectangle.png')"
      />


      <v-spacer></v-spacer>
      <v-btn :color=" isDark ? 'accent' : 'transparent'" :depressed="!isDark" fab small @click="switchTheme">
        <v-img :src="require('@/assets/icons/darkside_icon.png')" max-width="25"></v-img>
      </v-btn>
      <v-chip small outlined color="error" v-if="daysToExpire !== null">
        {{ daysToExpire === 0 ? '¡la prueba termina hoy!' : `quedan ${daysToExpire} días de prueba` }}
      </v-chip>
      <v-toolbar-items>
        <account-picker-btn v-if="showBranchOfficePicker"/>
        <account-menu-button :hideOnMobile="false" color="primary"></account-menu-button>
      </v-toolbar-items>

    </v-app-bar>
    <kimsa-drawer v-show="isMobile" v-if="$route.meta.menu  && isOnBoardingDone" :show="drawer" @change="drawer = $event" />
    <segment-menu v-show="!isMobile" />

  </div>

</template>

<script>
import AccountMenuButton from '../../../components/account/AccountMenuButton'
import KimsaDrawer from '../../../components/common/panel/KimsaDrawer'
import AccountPickerBtn from "../../../components/common/panel/AccountPickerBtn";
import {mapGetters, mapState} from 'vuex';
import SegmentMenu from "./SegmentMenu.vue";
import {colorArrayToLinearGradient} from "@/utils/UI";
import UIMixin from "@/mixins/UIMixin";

export default {
  props: [],
  mixins: [UIMixin],
  components: {
    SegmentMenu,
    KimsaDrawer,
    AccountPickerBtn,
    AccountMenuButton,
  },
  created() {
    const vm = this
  },
  data() {
    return {
      drawer: false
    }
  },
  computed: {
    ...mapState(['currentProvider']),
    ...mapGetters(['trialIsExpired']),
    barColor(){
      const vm = this
      return vm.bgColors[0] || vm.$vuetify.theme.primary
    },
    showBranchOfficePicker() {
      const vm = this
      if (!vm.$route.meta || vm.$route.meta.showBranchOfficePicker === undefined) {
        return true
      }

      return vm.$route.meta.showBranchOfficePicker

    },
    daysToExpire() {
      const vm = this
      if (!vm.currentProvider || !vm.currentProvider.trial_expires_at || vm.trialIsExpired) {
        return null
      }

      const now = vm.$moment();
      const trialEpiresAt = vm.$moment(vm.currentProvider.trial_expires_at)

      return trialEpiresAt.diff(now, 'days')

    }
  },
  methods: {
    colorArrayToLinearGradient,
    switchTheme(){
      const vm = this
      const dark = !vm.$vuetify.theme.dark
      vm.$store.commit('setIsDark', Boolean(dark))
      localStorage.setItem('darkMode', dark ? '1' : '0')
      vm.$vuetify.theme.dark = dark
    },
    onDrawerChange(val) {
      this.drawer = val
    }
  }
}

</script>

<style scoped>

</style>
